<template>
  <div class="flex items-start justify-between gap-6">
    <div class="flex items-center sm:max-w-[70%] lg:max-w-[80%]">
      <ProgramLogo
        class="relative z-2 mr-3"
        :program="program"
      />
      <div class="flex flex-1 flex-col">
        <h1>
          {{ program.name }}
        </h1>
        <span class="text-black">{{ program.short_description }}</span>
        <div>
          <span
            v-if="program.end_at"
            class="table mt-2.5 p-0.5 px-2 rounded bg-lightPurple flex-none"
          >
            {{ formatDate(program) }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex flex-col items-end gap-2 pt-2">
      <div
        v-if="program.organization.logo"
        class="flex-1 flex justify-end mr-2"
        :style="{height: `${size}px`, width: `${size}px`}"
      >
        <img
          class="object-cover object-center"
          :src="`${program.organization.logo}`"
          :alt="`${program.organization.id}`"
        >
      </div>
      <Toggle
        v-if="program.programmable_type === 'support'"
        :support-program-id="program.programmable_id"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import dateHelper from '@/core/helpers/dateHelper';
import ProgramLogo from '@/program/components/program-logo/ProgramLogo.vue';
import Toggle from "@/program/components/support-program/SupportProgramNotificationToggle/Toggle.vue";
import {Program} from "@/program/interfaces/Program";

const {size = 90, program} = defineProps<{
    size?: number;
    program: Program;
}>();

const localeDate = (date: string): string => dateHelper.shortFormat(new Date(date));

const formatDate = (program: Program): string => {
    if (program.end_at) {
        return `Jusqu'au ${localeDate(program.end_at)}`;
    } else {
        return 'Permanent';
    }
};
</script>
